/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  CountryCode,
  CreateExpedientRequest,
  CustomerSelection,
  ExpedientDto,
  NoteId,
  NoteInput,
  OfferOpeningAcknowledgement,
  OpenCustomerOfferRequest,
  PaginatedExpedientDto,
  RepresentativeSelection,
  UpdateExpedientRequest,
} from "../__ignore/schemas";

/**
 * Filters combine by AND; countryCodes values combine by OR. Absent state includes all states. Literal case-insensitive q searches name, alias, number. Sort defaults name ascending, with ascending UUID tie-break.
 * @summary List expedients
 */
export const listExpedientsQueryPageDefault = 1;

export const listExpedientsQueryPerPageDefault = 20;
export const listExpedientsQueryPerPageMax = 100;

export const listExpedientsQuerySortDirDefault = `asc`;
export const listExpedientsQuerySortKeyDefault = `name`;

export const ListExpedientsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).default(listExpedientsQueryPageDefault),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listExpedientsQueryPerPageMax)
    .default(listExpedientsQueryPerPageDefault),
  sortDir: zod.enum(["asc", "desc"]).default(listExpedientsQuerySortDirDefault),
  sortKey: zod.enum(["name", "number"]).default(listExpedientsQuerySortKeyDefault),
  q: zod.coerce.string().optional(),
  state: zod.enum(["ACTIVE", "DELETED", "CANCELED"]).optional(),
  countryCodes: zod.array(CountryCode).optional(),
  location: zod.enum(["ONSHORE", "OFFSHORE"]).optional(),
  customerId: zod.uuid().optional(),
  responsibleUserId: zod.uuid().optional(),
});

export const ListExpedientsResponse = PaginatedExpedientDto;

/**
 * Requires eligible customer/contact and optional Representative selection. Backend reserves YY.NNN and initializes responsibles with authenticated creator. No caller identity, number, Notes, responsible set or counter.
 * @summary Create expedient
 */
export const CreateExpedientBody = CreateExpedientRequest;

export const CreateExpedientResponse = zod.uuid();

/**
 * @summary Get expedient
 */
export const GetExpedientResponse = ExpedientDto;

/**
 * ACTIVE only. Full replacement; omitted/null optional groups clear. Retains parties, responsibles, Notes, identity, number and chain counter.
 * @summary Replace expedient descriptive and technical data
 */
export const UpdateExpedientBody = UpdateExpedientRequest;

export const UpdateExpedientResponse = zod.void();

/**
 * ACTIVE only; related Offer statuses/history remain unchanged.
 * @summary Soft-delete expedient
 */
export const DeleteExpedientResponse = zod.void();

/**
 * DELETED or CANCELED to ACTIVE, retaining preserved history.
 * @summary Restore expedient
 */
export const RestoreExpedientResponse = zod.void();

/**
 * ACTIVE to CANCELED; Offer mutation/creation freezes.
 * @summary Cancel expedient
 */
export const CancelExpedientResponse = zod.void();

/**
 * ACTIVE only; existing Offers retain captured selection.
 * @summary Change customer selection
 */
export const ChangeExpedientCustomerBody = zod.object({
  customer: CustomerSelection,
});

export const ChangeExpedientCustomerResponse = zod.void();

/**
 * ACTIVE only; new selection must be ACTIVE/EFFECTIVE with owned Contact and optional Commission. Existing Offers retain captured selection.
 * @summary Replace or clear Representative selection
 */
export const ChangeExpedientRepresentativeBody = zod.object({
  representative: zod.union([RepresentativeSelection, zod.null()]),
});

export const ChangeExpedientRepresentativeResponse = zod.void();

/**
 * ACTIVE dossier/user required; membership grants no permission.
 * @summary Add responsible user
 */
export const AddExpedientResponsibleBody = zod.object({
  responsibleUserId: zod.uuid(),
});

export const AddExpedientResponsibleResponse = zod.void();

/**
 * ACTIVE only; the requested user must be an assigned responsible. Reject absent membership without changing the set. Never remove the last member; the creator is otherwise removable.
 * @summary Remove responsible user
 */
export const RemoveExpedientResponsibleResponse = zod.void();

/**
 * ACTIVE only; backend assigns Note identity.
 * @summary Add expedient Note
 */
export const AddExpedientNoteBody = NoteInput;

export const AddExpedientNoteResponse = NoteId;

/**
 * ACTIVE only; preserve Note identity.
 * @summary Replace expedient Note
 */
export const EditExpedientNoteBody = NoteInput;

export const EditExpedientNoteResponse = zod.void();

/**
 * ACTIVE only.
 * @summary Remove expedient Note
 */
export const RemoveExpedientNoteResponse = zod.void();

/**
 * ACTIVE dossier/eligible captured parties required. Records original authenticated opener, allocated ordinal and one internal server-generated Offer UUID. Repeated internal delivery retains that UUID without creating another revision or overwriting later edits. DRAFT may retain unresolved input. Authored Chapters contain explicit commission applicability and no coefficient; private Customer pricing decisions and review/readiness attribution start unset. New references and protected financial creation must be authorized. Every sold catalog item requires an actual description in the input language even with null quantity or empty supplier choices; otherwise return sales.customerOffer.invalidSelection with located SOURCE_MISSING and do not open a chain. No name or other-language fallback is allowed.
 * @summary Open independent Offer chain
 */
export const OpenExpedientCustomerOfferBody = OpenCustomerOfferRequest;

export const OpenExpedientCustomerOfferResponse = OfferOpeningAcknowledgement;

/**
 * ACTIVE dossier/Template required. Copy language, currency, structure and remembered values; no Template Notes or coefficient decisions. Preserve structural optionality and explicit applyCommission, including false, independently of remembering. Start with unset Customer review/readiness attribution. Bind creator to opener; no later Template propagation. The committed opening retains one internal server-generated Offer UUID across repeated internal delivery without duplicate creation. Protected financial copying requires permission. Opening is new catalog admission: every copied sold item requires a description in the copied language. Missing descriptions, including retained invalid Template selections after a language change, return sales.customerOffer.invalidSelection with located SOURCE_MISSING. Preserve the source Template and create no chain or revision. Customer successor copying retains its separate repairable-reference policy.
 * @summary Open independent Offer from Template
 */
export const OpenExpedientCustomerOfferFromTemplateBody = zod.object({
  offerTemplateId: zod.uuid(),
});

export const OpenExpedientCustomerOfferFromTemplateResponse = OfferOpeningAcknowledgement;
